<template lang="pug">
  .input-text
    v-text-field(
      :label="label"
      :type="type"
      :counter="counter"
      v-model="getValue"
      :required="required"
      :readonly="readonly"
      :prepend-icon="prependIcon"
      :disabled="disabled"
      :rules="getRules"
      :maxlength="maxlength"
      :mask="mask"
      ref="inputText"
      @click="onClick($event)"
      @blur="onBlur($event)"
      @keyup.enter="onEnter($event)"
      @keypress="onKeypress($event)"
      :append-icon="icon"
      outline
      :min="min"
      :prefix="prefix"
      :suffix="suffix"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :error="error"
      :loading="loading"
      :return-masked-value="returnMaskedValue"

    )
      template(slot="append")
        slot(name="append")
          v-icon(
            v-if="iconAppend"
            @click="iconAppendClick($event)"
          ) {{ iconAppend }}
      template(
        v-if="prependIcon"
        slot="prepend"
      )
        v-icon.prependIconClass(
          :color="prependIconColor"
          @click="iconClick($event)"
        ) {{ prependIcon }}
</template>

<script>
import InputTextMixin from 'Support/components/inputs/InputTextMixin';

export default {
  name: 'InputText',
  mixins: [InputTextMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    maxlength: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    min: {
      type: [Boolean, String],
      default: false,
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    mask: {
      type: [String, Array],
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    prependIcon: {
      type: String,
      default: '',
    },
    prependIconColor: {
      type: String,
      default: '',
    },
    iconAppend: {
      type: String,
      default: '',
    },
    counter: {
      type: [Number, String],
      default: null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    returnMaskedValue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEnter(value) {
      this.$emit('keyup:enter', value);
    },
    iconAppendClick() {
      this.$emit('icon-click');
    },
    iconClick() {
      this.$emit('icon-click');
    },
    onKeypress($event) {
      this.$emit('keypress', $event);
    },
  },
};
</script>

<style lang="stylus">
  .input-text
    .theme--light
      &.v-text-field--outline
        & > .v-input__control
          & > .v-input__slot
            height 45px
            min-height 45px
            border solid 1px #E0E0E0
            box-sizing border-box
            margin-top 5px
            margin-bottom  0 !important
  .input-text
    .theme--light
      &.v-text-field--outline
        &:not(.v-input--is-focused):not(.v-input--has-state)
          & > .v-input__control
            & > .v-input__slot
              &:hover
                border 1px solid #369CE2
                color #369CE2
  .input-text .v-text-field--box .v-label,
  .input-text .v-text-field--full-width .v-label,
  .input-text .v-text-field--outline .v-label
    top 12px
    font-size 14px
  .input-text .v-text-field--box input,
  .input-text .v-text-field--full-width input,
  .input-text .v-text-field--outline input
    margin-top 6px
  .input-text .v-text-field .v-label--active
    top -2px !important
    background #FAFAFA
    padding 0 5px
  .input-text .v-text-field--box:hover .v-label,
  .input-text .v-text-field--full-width:hover .v-label,
  .input-text .v-text-field--outline:hover .v-label
    color #369CE2
  .input-text .v-input--is-focused .v-input__slot
    border 1px solid #369CE2 !important
  .v-text-field.v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field.v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field.v-text-field--enclosed .v-input__append-inner,
  .v-text-field.v-text-field--enclosed .v-input__append-outer
    margin-top 10px
  .input-text
    .v-text-field.v-text-field--enclosed
      .v-text-field__details
        margin-top 5px !important
        margin-bottom 0 !important;
        min-height 17px !important
  .prependIconClass {
    margin-top: 0.7vh !important;
  }
</style>
